<template>
    <div>
        <transition name="fade">

            <div id="modal-order" class="modal" :class="{'is-active': messageModal}">
                <div class="modal-background" ></div>
                <div class="modal-content">
                    <!-- Any other Bulma elements you want -->
                    <i class="fa fa-close f-modal-close" @click="$emit('closeMessage')"></i>


                    <img class="modallogo" src="/static/images/layout/logo_FORM.png" alt="Facilimo">

                    <p v-html="messageModal" class="f-modal-text"></p>

                    <p>&nbsp;</p>

<!--

                    <div class="control">
                        <a class="button bmod is-fullwidth" @click="$emit('closeMessage')">
                            Continuar
                        </a>
                    </div>-->


                </div>
            </div>
        </transition>

    </div>

</template>

<script>
export default {
  props: ["messageModal"]
};
</script>
<style scoped>
.modallogo {
  height: 3rem;
}

.modallogorpc {
  min-height: 3rem;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background-color: #e90054;
  padding: 2rem 0;
  text-align: center;
  border-radius: 5px;
  min-height: 66vh;
  max-height: 66vh;
}

.f-modal-text {
  padding: 2rem 4rem;

  text-align: left;
  color: white;
  font-size: 1.75rem;
  //margin: 2rem 0;
}

.f-modal-close {
  color: #eac5d9;
  position: absolute;
  font-size: 2rem;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
}

.button {
  border-radius: 5px;
  font-size: 1.5rem;
  font-weight: 400;
  padding: 1em 2rem;
  height: 4rem;
}

.bmod {
  background-color: #eac5d9;
  color: #e90054;
}

@media only screen and (min-width: 769px) {
}

@media only screen and (max-width: 768px) {
  .modal-content {
    padding: 4rem 2rem;
  }
  .f-modal-text {
    color: white;
    font-size: 1.5rem;
    margin: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalMessage.vue